import React from 'react';
import classnames from 'classnames';

import styles from './index.module.css';

export interface CommentCardProperty {
	imgSrc: string;
	jobTitle: string;
	name: string;
	content: string;
	backgroundColor?: string;
	className?: string;
}

const CommentCard: React.FC<CommentCardProperty> = ({
	imgSrc,
	jobTitle,
	name,
	content,
	backgroundColor,
	className,
}) => (
	<div className={classnames(styles.commentCard, className)} style={{ backgroundColor }}>
		<img src={imgSrc} alt="profile" />
		<p className={styles.jobTitle}>{jobTitle}</p>
		<p className={styles.name}>{name}</p>
		<p className={styles.content}>“{content}”</p>
	</div>
);

export default CommentCard;
